import { CaseNoteResponse } from "@/api";

/** Mirrors the backend's `CaseNoteTypeKeys.Edict`. */
const EDICT_CASE_NOTE_TYPE = "EDIKT";

export function isEdictCaseNote(caseNote: CaseNoteResponse | null): caseNote is CaseNoteResponse {
  return caseNote?.type === EDICT_CASE_NOTE_TYPE;
}
